import { EyeOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import dayjs from 'dayjs';

import type { LoggerLogDto } from '@app/api/Logger';
import type { GetEmailLogsColumnsProps } from '@app/pages/EmailLogs/types';

import type { ColumnsType } from 'antd/es/table';

const trimOneLine = (s?: string | null, max = 30) =>
  (s ?? '').replace(/\s+/g, ' ').trim().slice(0, max);

export const getEmailLogsColumns = ({
  openLog,
}: GetEmailLogsColumnsProps): ColumnsType<LoggerLogDto> => {
  return [
    {
      title: 'Дата',
      dataIndex: 'Timestamp',
      key: 'Timestamp',
      fixed: 'left',
      render: (text: string) => (
        <span className="no-wrap-text">
          {dayjs(text).format('DD.MM.YYYY HH:mm:ss')}
        </span>
      ),
    },
    {
      title: 'Уровень',
      dataIndex: 'Level',
      key: 'Level',
      render: (text: string | null) => (
        <span className="no-wrap-text">{text ?? '-'}</span>
      ),
    },
    {
      title: 'Модуль',
      dataIndex: 'Module',
      key: 'Module',
      render: (text: string | null) => (
        <span className="no-wrap-text">{text ?? '-'}</span>
      ),
    },
    {
      title: 'Сообщение',
      dataIndex: 'Message',
      key: 'Message',
      ellipsis: { showTitle: false },
      render: (text: string | null) => <span>{trimOneLine(text)}</span>,
    },
    {
      title: 'Exception',
      dataIndex: 'Exception',
      key: 'Exception',
      ellipsis: { showTitle: false },
      render: (text: string | null) =>
        text ? (
          <span>{trimOneLine(text)}</span>
        ) : (
          <span className="no-wrap-text">—</span>
        ),
    },
    {
      title: '',
      dataIndex: 'Id',
      key: 'Action',
      render: (Id: number) => (
        <Button
          type="text"
          icon={<EyeOutlined />}
          onClick={() => openLog(Id)}
        />
      ),
    },
  ];
};
